import type React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { browserName } from 'react-device-detect';
import Cookies from 'js-cookie';

const COOKIE_NAME = 'BrowserDialog';

function shouldShowBrowserNotification(): boolean {
  const isAlreadyShown = Cookies.get(COOKIE_NAME) === 'Opened';
  const isNotRecommendedBrowser = !['Edge', 'Chrome', 'Chrome Headless', 'Mobile Safari', 'Safari'].includes(
    browserName
  );
  return isNotRecommendedBrowser && !isAlreadyShown;
}

export const BrowserNotificationModal: React.FC = () => {
  const [open, setOpen] = useState(shouldShowBrowserNotification());

  const handleClose = (): void => {
    setOpen(false);
    Cookies.set(COOKIE_NAME, 'Opened', { path: '/', expires: 365 });
  };

  return (
    <div>
      <Dialog open={open}>
        <ModalContainer>
          <DialogTitle id="browser-notification-dialog-title" sx={{ m: 0, p: 2, fontWeight: '600' }}>
            Note
          </DialogTitle>
          <DialogContent dividers>
            <ModalContentBody>
              Please use the latest version of one of the following browsers depending on your OS to ensure an optimal
              experience of using the application:
              <StyledList>
                <li>Google Chrome (Windows OS desktop, Mac OS)</li>
                <li>Safari (iOS, Mac OS)</li>
                <li>Edge (Windows OS desktop)</li>
              </StyledList>
            </ModalContentBody>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'end', alignItems: 'center' }}>
            <Button onClick={handleClose}>Continue</Button>
          </DialogActions>
        </ModalContainer>
      </Dialog>
    </div>
  );
};

const ModalContainer = styled.div`
  width: 590px;
  padding-bottom: 10px;
`;

const ModalContentBody = styled.div`
  p.current-year {
    text-align: right;
    font-size: 0.8em;
  }
`;

const StyledList = styled.ul`
  padding: 1em 2em;
`;
